module.exports = __webpack_public_path__ + "img/Traktor_BM_700.jpg";